export const techProfessions = [
    'Software Engineer',
    'Full-Stack Developer',
    'Frontend Developer',
    'Backend Developer',
    'Mobile App Developer',
    'Game Developer',
    'DevOps Engineer',
    'Embedded Systems Developer',
    'Firmware Engineer',
    'Data Scientist',
    'Data Analyst',
    'Data Engineer',
    'Machine Learning Engineer',
    'Business Intelligence Analyst',
    'AI Researcher',
    'Big Data Engineer',
    'Cloud Solutions Architect',
    'Cloud Engineer',
    'Cloud Security Specialist',
    'Site Reliability Engineer (SRE)',
    'AWS Solutions Architect',
    'Azure Cloud Engineer',
    'GCP Cloud Engineer',
    'Cybersecurity Analyst',
    'Ethical Hacker (Penetration Tester)',
    'Security Engineer',
    'Incident Response Specialist',
    'Security Consultant',
    'Chief Information Security Officer (CISO)',
    'Forensics Expert',
    'Network Engineer',
    'Network Administrator',
    'Systems Administrator',
    'IT Support Specialist',
    'Network Architect',
    'VoIP Engineer',
    'Wireless Network Engineer',
    'Database Administrator (DBA)',
    'Database Developer',
    'SQL Developer',
    'NoSQL Engineer',
    'Data Architect',
    'IT Project Manager',
    'Scrum Master',
    'Agile Coach',
    'Product Manager',
    'Technical Program Manager',
    'Quality Assurance (QA) Engineer',
    'Automation Tester',
    'Manual Tester',
    'Performance Tester',
    'Test Analyst',
    'UI/UX Designer',
    'UX Researcher',
    'Interaction Designer',
    'Product Designer',
    'Graphic Designer',
    'Technical Writer',
    'API Documentation Writer',
    'UX Writer',
    'AI Engineer',
    'NLP Specialist',
    'Deep Learning Engineer',
    'Robotics Engineer',
    'Computer Vision Engineer',
    'Blockchain Developer',
    'Blockchain Architect',
    'Smart Contract Developer',
    'Cryptocurrency Developer',
    'Technical Support Engineer',
    'IT Help Desk Specialist',
    'Desktop Support Technician',
    'IT Operations Manager',
    'Systems Analyst'
];
